import { createFileRoute } from '@tanstack/react-router'
import { FinanceRulesPage } from '_/features/finance/ui/pages/finance-rules-page'

export const Route = createFileRoute('/_authenticated/finance/rules')({
	staticData: { title: 'finance_rules_title' },
	component: FinanceRulesPage,
})
